import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { RfcPage } from './rfc.component';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'rfc',
    component: RfcPage,
    canActivate: [authGuard, hasRoleGuard(null, ['use_rfc'])],
    data: {
      title: "RFC"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class RfcPageRoutingModule { }
